import { render } from "./ChildDevelopmentClassContainer.vue?vue&type=template&id=eb21e5b2&ts=true"
import script from "./ChildDevelopmentClassContainer.vue?vue&type=script&lang=ts"
export * from "./ChildDevelopmentClassContainer.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__